import { Header } from "semantic-ui-react";

import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import Flex from "../../../../components/Flex/Flex";
import PrimaryButton from "../../../ui/components/Buttons/PrimaryButton";
import CollectionDataTable from "../../../ui/components/CollectionDataTable/CollectionDataTable";

import usePricesQuery from "../../hooks/usePricesQuery";

import usePricesTableColumns from "./hooks/usePricesTableColumns";

export default function PricesView({ producerId, ...props }) {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const query = usePricesQuery({ producerId });
	const columns = usePricesTableColumns();

	return (
		<>
			<Flex gap={10} wrap style={{ marginBottom: 15 }}>
				<div>
					<Header as="h2">{t("globalPrices", "Global prices")}</Header>
				</div>

				<div style={{ whiteSpace: "nowrap" }}>
					<Flex gap={10} justifyContent="flex-start">
						<PrimaryButton as={Link} to="create">
							{t("addPrices", "Add prices")}
						</PrimaryButton>
					</Flex>
				</div>
			</Flex>

			<CollectionDataTable
				persist
				filterable
				query={query}
				columns={columns}
				onClick={({ id }) => navigate(id)}
				sortBy={{
					id: "created",
					desc: true,
				}}
				{...props}
			/>
		</>
	);
}
